import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SpecialistDetectionClaimData } from 'app/core/models/provider-specialist-detection-llm-result.model';

export class SpecialistDetectionClaimsModalData {
  claims: SpecialistDetectionClaimData[] = [];
}

@Component({
  selector: 'app-specialist-detection-claims-modal',
  templateUrl: './specialist-detection-claims-modal.component.html',
})
export class SpecialistDetectionClaimsModalComponent {
  activeModal = inject(NgbActiveModal);
  data = inject(SpecialistDetectionClaimsModalData);

  onCloseClick() {
    this.activeModal.close();
  }
}
